/* eslint-disable import/no-cycle */
import { IBaseEmployee } from './Employee';

export enum BankReconciliationReportType {
  DAILY_CREDITS = 'daily_credits',
  DAILY_DEBITS = 'daily_debits',
  DETAILED_CREDITS = 'detailed_credits',
  DETAILED_DEBITS = 'detailed_debits',
}

export enum LedgerEntryType {
  CREDIT = 'credit',
  DEBIT = 'debit',
  PENDING_CREDIT = 'pending_credit',
  PENDING_CREDIT_REVERTED = 'pending_credit_reverted',
  SITE_CREATED = 'site_created',
}

export enum TransactionReferenceType {
  ACH = 'ach',
  BALANCE_ADJUSTMENT = 'balance_adjustment',
  PAYOUT = 'payout',
  SITE = 'site',
}

export interface ILedgerEntry {
  id: string;
  amount: number;
  balance: number;
  employee?: IBaseEmployee;
  entryType: LedgerEntryType;
  description: string;
  pendingFunds: number;
  seqNum: number;
  txnRefId: string;
  txnRefNotes?: string;
  txnRefType: TransactionReferenceType;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface ILedgerEntryByDate {
  date: string;
  amount: number;
}
